import { createStyles } from "@mantine/core"

export const useStyles = createStyles(() => ({
    content: {
        // Create a new stacking context, so the content renders below the header and footer, regardless of z-index!
        position: "relative",
        zIndex: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}))
